"use client"

import { useTheme } from "../context/ThemeContext"

import { MoonIcon, SunIcon } from "lucide-react"
import { Link } from "react-router"

function HeaderBeforeLogin() {

  const { theme, toggleTheme } = useTheme()

  return (
    <header className="header">
      <div className="lg:w-10/12 mx-auto flex items-center justify-between">
        <div className="logo">
          <a href="https://kaxaa.com" rel="noopener noreferrer">
            <img width={'160'} src="/assets/kax-logo.svg" alt="Kaxaa Logo" />
          </a>
        </div>

        <button className="p-2 rounded-full cursor-pointer transition-opacity hover:opacity-100" onClick={toggleTheme}>
          {theme === "dark" ? <SunIcon /> : <MoonIcon strokeWidth={1.5} />}
        </button>

      </div>
    </header>
  )
}

export default HeaderBeforeLogin
